import {useLocation} from 'react-router-dom';
import {AUTH_INIT_MODELS} from '@chekin/core';
import {useReservation} from 'context/reservation';
import {useChekinSDK} from 'context/ChekinSDK';
import {isUnattendedTerminal} from 'hooks/terminalMode';
import {closeSession, hasSession, resetTerminal} from 'components/sessions/utils';
import {PATHS} from 'routes/constants';

export type SessionExpiryPolicy = {
  enabled: boolean;
  inactivityLimit: number;
  countdown: number;
  onExpire: () => void;
};

const GUEST = {inactivityLimit: 120_000, countdown: 60};
const UNATTENDED = {inactivityLimit: 60_000, countdown: 15};

export const useSessionExpiryPolicy = (): SessionExpiryPolicy => {
  const {reservationId} = useReservation();
  const {modelName} = useChekinSDK();
  const {pathname} = useLocation();

  if (isUnattendedTerminal()) {
    return {
      ...UNATTENDED,
      enabled: !pathname.includes(PATHS.searchReservation.welcomeScreen),
      onExpire: () => resetTerminal(reservationId, PATHS.searchReservation.welcomeScreen),
    };
  }

  return {
    ...GUEST,
    enabled: hasSession(reservationId) && modelName !== AUTH_INIT_MODELS.housing,
    onExpire: () => closeSession(reservationId),
  };
};
